/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import {
  FiCalendar,
  FiTrash,
  FiEdit,
  IoDuplicateOutline,
  FiClock,
} from 'react-icons/all';
import DetailPengajuanPelatihanController, {
  useDetailPengajuanPelatihanDataPengajuanPelatihanContext,
} from '../../../../../../controller/admin/manajemen_pelatihan/pengajuan_pelatihan/detail/data_pengajuan_pelatihan';
import { ToastContainer } from 'react-toastify';
import ReactLoading from 'react-loading';
import { If, Then, Else } from 'react-if';
import moment from 'moment';
import parse from 'html-react-parser';
import SidebarWithHeader from '../../../../../../components/Admin/SidebarWithHeader';
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Heading,
  Icon,
  Image,
  Tag,
  Text,
  Button,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Stack,
  Skeleton,
  Input,
  Divider,
} from '@chakra-ui/react';
import ManajemenSertifikatController, {
  useManajemenSertifikatContext,
} from '../../../../../../controller/admin/manajemen_sertifikat';
import Select from 'react-select';
import MasterTTEContext, {
  useMasterTTEContext,
} from '../../../../../../controller/admin/data_master/tte';
import { GetAuthData } from '../../../../../../../misc/GetAuthData';
import Loader from '../../../../../../components/Loader';
import ContentPengajuanPelatihan from '../../../../../../components/Admin/ContentPelatihan/ContentPengajuanPelatihan';
import DetailPengajuanPelatihanKontenPengajuanPelatihanController, {
  useDetailPengajuanPelatihanKontenPengajuanPelatihanContext,
} from '../../../../../../controller/admin/manajemen_pelatihan/pengajuan_pelatihan/detail/konten_pengajuan_pelatihan';
import { ReactComponent as TerimaIcon } from '../../../../../../assets/svg/ic_terima.svg';
import { ReactComponent as TolakIcon } from '../../../../../../assets/svg/ic_tolak.svg';

const colors = {
  star: ['#FFDA6A', '#FFDA6A', '#434b4d'],
};

const HeaderBanner: React.FC = () => {
  const { pengajuanPelatihan, isLoading, isLoadingDuplicate } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;

  const { setSelectedId, setShowDialogDelete, setModalDuplicate } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  const level = GetAuthData()?.level;

  return (
    <Box borderRadius="md" background="GreenPrimary.500" boxShadow="lg">
      {isLoading ? (
        <Stack direction="column" p={7}>
          <Box>
            <Skeleton height="250px" borderRadius="md" />
          </Box>
          <Stack>
            <Skeleton height="40px" borderRadius="md" />
            <Skeleton height="40px" borderRadius="md" />
          </Stack>
        </Stack>
      ) : (
        <Grid
          templateColumns={{
            lg: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            sm: 'repeat(1, 1fr)',
          }}
          gap={7}
          p={7}
        >
          <GridItem zIndex={1}>
            <Box
              rounded={'lg'}
              _groupHover={{
                _after: {
                  filter: 'blur(20px)',
                },
              }}
            >
              <Image
                rounded={'lg'}
                width="500px"
                h="300px"
                objectFit={'cover'}
                src={pengajuanPelatihan?.path_thumbnail}
              />
            </Box>
          </GridItem>
          <GridItem>
            <Heading
              fontSize={'2xl'}
              fontFamily={'body'}
              fontWeight={700}
              color="white"
            >
              {pengajuanPelatihan?.judul_pelatihan}
            </Heading>
            <Tag colorScheme="whatsapp" px={4} py={2} my={4}>
              {pengajuanPelatihan?.penyelenggara}
            </Tag>

            <Flex
              alignItems="center"
              color="white"
              fontSize={18}
              fontWeight={600}
              mt={2}
            >
              <Icon as={FiCalendar} mr={2} color={'gold'} />
              <Text fontSize={18}>
                {moment(pengajuanPelatihan?.waktu_mulai).format('LL')} s.d{' '}
                {moment(pengajuanPelatihan?.waktu_selesai).format('LL')}
              </Text>
            </Flex>

            <Flex
              alignItems="center"
              color="white"
              fontSize={18}
              fontWeight={600}
              mt={2}
            >
              <Icon as={FiClock} mr={2} color={'gold'} />
              <Text fontSize={18}>{pengajuanPelatihan?.jp} JP</Text>
            </Flex>

            {level === 'adminmitrakerjalembaga' && (
              <Flex mt={4}>
                <Button
                  colorScheme="red"
                  color="white"
                  mr={4}
                  fontSize={16}
                  onClick={() => {
                    setSelectedId(pengajuanPelatihan?.id);
                    setShowDialogDelete(true);
                  }}
                >
                  <Flex>
                    Hapus
                    <Icon as={FiTrash} ml={2} />
                  </Flex>
                </Button>
                {pengajuanPelatihan?.status_pengajuan != 'diterima' ? (
                  <Button
                    as="a"
                    href={`/admin/ubah/manajemen_pengajuan_pelatihan/${
                      window.location.pathname.split('/', 6)[5]
                    }`}
                    colorScheme="blue"
                    color="white"
                    fontSize={16}
                    mr={4}
                  >
                    <Flex>
                      Edit
                      <Icon as={FiEdit} ml={2} />
                    </Flex>
                  </Button>
                ) : (
                  ''
                )}
                <Button
                  colorScheme="whatsapp"
                  fontSize={16}
                  rightIcon={<IoDuplicateOutline />}
                  isLoading={isLoadingDuplicate}
                  onClick={() => {
                    setModalDuplicate(true);
                  }}
                >
                  Duplikat
                </Button>
              </Flex>
            )}

            {level === 'admin' ||
              (level === 'superadmin' && (
                <Flex mt={4}>
                  <Button
                    colorScheme="whatsapp"
                    fontSize={16}
                    rightIcon={<IoDuplicateOutline />}
                    isLoading={isLoadingDuplicate}
                    onClick={() => {
                      setModalDuplicate(true);
                    }}
                  >
                    Duplikat
                  </Button>
                </Flex>
              ))}
          </GridItem>
        </Grid>
      )}
    </Box>
  );
};

const DetailPengajuanPelatihan: React.FC = () => {
  const { pengajuanPelatihan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;

  return (
    <Box>
      <Flex mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Judul Pelatihan
        </Heading>
        <Text fontSize="md" w="80%">
          : {pengajuanPelatihan?.judul_pelatihan}
        </Text>
      </Flex>
      <Flex mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Angkatan
        </Heading>
        <Text fontSize="md" w="80%">
          : {pengajuanPelatihan?.angkatan}
        </Text>
      </Flex>
      <Flex mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Waktu Mulai Pelaksanaan Pelatihan
        </Heading>
        <Text fontSize="md" w="80%">
          : {moment(pengajuanPelatihan?.waktu_mulai).format('LL')} s.d{' '}
          {moment(pengajuanPelatihan?.waktu_selesai).format('LL')}
        </Text>
      </Flex>
      <Flex mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Waktu Mulai Pendaftaran Pelatihan
        </Heading>
        <Text fontSize="md" w="80%">
          : {moment(pengajuanPelatihan?.waktu_buka_pendaftaran).format('LL')}{' '}
          s.d {moment(pengajuanPelatihan?.waktu_tutup_pendaftaran).format('LL')}
        </Text>
      </Flex>
      <Flex mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Penyelenggara Pelatihan
        </Heading>
        <Text fontSize="md" w="80%">
          : {pengajuanPelatihan?.penyelenggara}
        </Text>
      </Flex>
      <Flex direction="column" mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Informasi Umum Pelatihan
        </Heading>
        <Box fontSize="md">
          {parse(
            pengajuanPelatihan?.informasi_umum != null
              ? pengajuanPelatihan.informasi_umum
              : '-'
          )}
        </Box>
      </Flex>
      <Flex direction="column" mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Kompetensi Teknis Pelatihan
        </Heading>
        <Box fontSize="md">
          {parse(
            pengajuanPelatihan?.kompetensi_teknis != null
              ? pengajuanPelatihan.kompetensi_teknis
              : '-'
          )}
        </Box>
      </Flex>
      <Flex direction="column" mb={4}>
        <Heading fontSize="md" fontWeight="semibold" w="20%" mb={1}>
          Syarat Pelatihan
        </Heading>
        <Box fontSize="md">
          {parse(
            pengajuanPelatihan?.persyaratan != null
              ? pengajuanPelatihan.persyaratan
              : '-'
          )}
        </Box>
      </Flex>
    </Box>
  );
};

const Penilaian = () => {
  const { modulPelatihan } =
    useDetailPengajuanPelatihanKontenPengajuanPelatihanContext().state;
  const { pengajuanPelatihan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;

  return (
    <Box>
      <Heading as="h4" p={5} fontSize="lg">
        Bobot Penilaian
      </Heading>
      <Divider mb={2} />
      {modulPelatihan.length
        ? modulPelatihan.map((item, i) => {
            return (
              <Box px={8} py={2} key={item.id}>
                <Text fontSize="md" fontWeight="semibold">
                  Section {i + 1}. {item.judul_modul}
                </Text>

                <Box mx={4}>
                  {item.subModulPelatihan.map((sm) => {
                    return (
                      <Grid
                        templateColumns={{
                          md: 'repeat(11, 1fr)',
                          sm: 'repeat(3, 1fr)',
                        }}
                        gap={5}
                        mt={2}
                        key={sm.id}
                      >
                        <GridItem colSpan={{ md: 2, sm: 1 }}>
                          <Text
                            as="label"
                            htmlFor="judul"
                            display="inline-block"
                            py={2}
                            color="gray.700"
                            fontWeight="md"
                            className="form-label"
                          >
                            {sm.judul}
                          </Text>
                        </GridItem>
                        <GridItem colSpan={{ md: 5, sm: 1 }}>
                          <Input
                            type="number"
                            readOnly
                            defaultValue={
                              (sm.ada_latihan === 0 && sm.jenis_ujian === '') ||
                              pengajuanPelatihan?.jenis_penilaian_id === 2
                                ? 0
                                : sm.bobot_penilaian
                            }
                            placeholder="Tidak Ada Nilai"
                            className="form-control"
                            bg="white"
                            border="1px solid"
                            borderColor="gray.300"
                            rounded="md"
                            transition="ease-in-out"
                            m={0}
                            _focus={{
                              color: 'gray.700',
                              bg: 'white',
                              borderColor: 'blue.600',
                              outline: 'none',
                            }}
                          />
                        </GridItem>
                      </Grid>
                    );
                  })}
                </Box>
              </Box>
            );
          })
        : null}
    </Box>
  );
};

const ApprovalPelatihan: React.FC = () => {
  const { pengajuanPelatihan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;
  const {
    setShowDialogTolakPengajuan,
    setShowDialogTerimaPengajuan,
    setSelectedId,
  } = useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  if (pengajuanPelatihan?.status_pengajuan != 'diterima') {
    if (pengajuanPelatihan?.status_pengajuan == 'ditolak') {
      return (
        <div>
          <Box background="white" p={4} borderRadius="md" mt={4}>
            <Flex className="justify-between">
              <h3 className="font-bold">Tinjau Pengajuan Jenis Pelatihan</h3>
              <div>
                <button
                  className="ml-2 px-2 py-1 text-sm text-yellow-500 bg-yellow-50 border border-yellow-500 rounded-lg"
                  onClick={() => {
                    setSelectedId(pengajuanPelatihan?.id);
                    setShowDialogTerimaPengajuan(true);
                  }}
                >
                  Revisi
                </button>
              </div>
            </Flex>
          </Box>
          <Box background="white" p={4} borderRadius="md" mt={4}>
            <h3 className="text-red-700 font-bold">Pelatihan Ditolak</h3>
            <p className="p-2 text-red-500 bg-red-100 border border-red-500 rounded-lg mt-2 text-justify">
              {pengajuanPelatihan?.alasan}
            </p>
          </Box>
        </div>
      );
    } else {
      return (
        <Box background="white" p={4} borderRadius="md" mt={4}>
          <Flex className="justify-between">
            <h3>Tinjau Pengajuan Jenis Pelatihan</h3>
            <div>
              <button
                className="ml-2 px-2 py-1 text-sm text-green-800 bg-green-200 border border-green-900 rounded-lg"
                onClick={() => {
                  setSelectedId(pengajuanPelatihan?.id);
                  setShowDialogTerimaPengajuan(true);
                }}
              >
                Terima
              </button>
              <button
                className="ml-2 px-2 py-1 text-sm text-red-800 bg-red-200 border border-red-900 rounded-lg"
                onClick={() => {
                  setSelectedId(pengajuanPelatihan?.id);
                  setShowDialogTolakPengajuan(true);
                }}
              >
                Tolak
              </button>
            </div>
          </Flex>
        </Box>
      );
    }
  } else {
    return <></>;
  }
};

const TabsMenu: React.FC = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const action = urlSearchParams.get('action') ?? '';

  const { isLoading } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;

  let initialTabIndex = 0;
  if (action === 'get-pretest') {
    initialTabIndex = 3; // Indeks tab "Daftar Peserta"
  }

  return (
    <Box background="white" p={4} borderRadius="md" mt={4}>
      {isLoading ? (
        <Loader />
      ) : (
        <Tabs variant="unstyled" isLazy defaultIndex={initialTabIndex}>
          <TabList justifyContent="space-between">
            <Grid
              templateColumns={{
                base: 'repeat(2, 1fr)',
                md: 'repeat(4, 1fr)',
              }}
              gap={{ base: 2, md: 0 }}
            >
              <Tab
                _selected={{ color: 'white', bg: 'green.500', fontWeight: 700 }}
                borderRadius={{ base: 'md', md: 'none' }}
                borderTopLeftRadius={{ base: 'md', md: 'md' }}
                borderBottomLeftRadius={{ base: 'md', md: 'md' }}
                background="gray.200"
                color="gray.500"
              >
                Data Pengajuan Pelatihan
              </Tab>
              <Tab
                _selected={{ color: 'white', bg: 'green.500', fontWeight: 700 }}
                borderRadius={{ base: 'md', md: 'none' }}
                background="gray.200"
                color="gray.500"
              >
                Konten Pelatihan
              </Tab>
              <Tab
                _selected={{ color: 'white', bg: 'green.500', fontWeight: 700 }}
                borderRadius={{ base: 'md', md: 'none' }}
                borderTopRightRadius={{ base: 'md', md: 'md' }}
                borderBottomRightRadius={{ base: 'md', md: 'md' }}
                background="gray.200"
                color="gray.500"
              >
                Penilaian
              </Tab>
            </Grid>
          </TabList>
          <TabPanels p={0} mt={5}>
            <TabPanel p={0}>
              <DetailPengajuanPelatihan />
            </TabPanel>
            <TabPanel p={0}>
              <ContentPengajuanPelatihan />
            </TabPanel>
            <TabPanel p={0}>
              <Penilaian />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </Box>
  );
};

const ModalDelete: React.FC = () => {
  const { showDialogDelete, isLoadingDelete } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;
  const { setShowDialogDelete, deletePengajuanPelatihan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  return (
    <>
      {showDialogDelete ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-3xl p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900">
                    Hapus PengajuanPelatihan
                  </h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialogDelete(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2">
                  Apakah Anda Yakin Ingin Menghapus Data Ini?
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-end -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialogDelete(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-red-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => deletePengajuanPelatihan()}
                  >
                    <If condition={isLoadingDelete}>
                      <Then>
                        <ReactLoading
                          type={'bars'}
                          color={'white'}
                          height={15}
                          width={20}
                        />
                      </Then>
                      <Else>Yakin</Else>
                    </If>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const ModalTolakPengajuan: React.FC = () => {
  const { showDialogTolakPengajuan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;
  const { setShowDialogTolakPengajuan, setShowDialogFormTolakPengajuan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  return (
    <>
      {showDialogTolakPengajuan ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-md p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900"></h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialogTolakPengajuan(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2 justify-center">
                  <div className="flex justify-center">
                    <TolakIcon />
                  </div>
                  <h2 className="font-bold text-md text-center">
                    Apakah anda yakin ingin menolak pengajuan ini?
                  </h2>
                  <p className="text-center">
                    Pengajuan ini akan ditolak tidak dapat dikembalikan.
                  </p>
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-center -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialogTolakPengajuan(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => setShowDialogFormTolakPengajuan(true)}
                  >
                    Ya
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const ModalFormTolakPengajuan: React.FC = () => {
  const { showDialogFormTolakPengajuan, isLoadingApproval, formAlasan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;
  const {
    setShowDialogFormTolakPengajuan,
    actionDialogFormTolakPengajuan,
    setFormAlasan,
  } = useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  return (
    <>
      {showDialogFormTolakPengajuan ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-3xl p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900">
                    Tolak Pengajuan Jenis Pelatihan
                  </h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialogFormTolakPengajuan(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2">
                  <label className="form-label inline-block py-1.5 text-gray-700 font-medium col-span-2">
                    Alasan Menolak Pengajuan{' '}
                    <span className="text-red-700">*</span>
                  </label>
                  <textarea
                    rows={5}
                    className="form-control
                          block
                          w-full
                          px-3
                          col-span-4
                          py-1.5
                          text-base
                          font-normal
                          text-gray-700
                          bg-white bg-clip-padding
                          border border-solid border-gray-300
                          rounded
                          transition
                          ease-in-out
                          m-0
                          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    value={formAlasan}
                    onChange={(e) => setFormAlasan(e.target.value)}
                    placeholder="Masukkan Form Alasan"
                  />
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-end -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialogFormTolakPengajuan(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-red-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => actionDialogFormTolakPengajuan()}
                  >
                    <If condition={isLoadingApproval}>
                      <Then>
                        <ReactLoading
                          type={'bars'}
                          color={'white'}
                          height={15}
                          width={20}
                        />
                      </Then>
                      <Else>Tolak</Else>
                    </If>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const ModalTerimaPengajuan: React.FC = () => {
  const { showDialogTerimaPengajuan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext().state;
  const { setShowDialogTerimaPengajuan, actionDialogFormTerimaPengajuan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  return (
    <>
      {showDialogTerimaPengajuan ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-md p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900"></h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialogTerimaPengajuan(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2 justify-center">
                  <div className="flex justify-center">
                    <TerimaIcon />
                  </div>
                  <h2 className="font-bold text-md text-center">
                    Apakah anda yakin ingin menerima pengajuan ini?
                  </h2>
                  <p className="text-center">
                    Pengajuan ini akan diterima tidak dapat dikembalikan.
                  </p>
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-center -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialogTerimaPengajuan(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => actionDialogFormTerimaPengajuan()}
                  >
                    Ya
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const ModalTTESertifikat: React.FC = () => {
  const { setShowDialog, tteSertifikat, setAccountTTESelected } =
    useManajemenSertifikatContext();
  const { showDialog, isLoading, tteAction } =
    useManajemenSertifikatContext().state;

  const { listDataOption: listAccountTTEOption } = useMasterTTEContext().state;

  return (
    <>
      {showDialog ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-3xl p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900">
                    TTE Sertifikat PengajuanPelatihan
                  </h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialog(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2">
                  {/* Alert */}
                  <div
                    id="alert-4"
                    className="flex p-4 mb-4 bg-yellow-100 rounded-lg"
                    role="alert"
                  >
                    <svg
                      aria-hidden="true"
                      className="flex-shrink-0 w-5 h-5 text-yellow-700"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="sr-only">Info</span>
                    <div className="ml-3">
                      <p className="text-md font-semibold text-yellow-700">
                        Tanda Tangan Elektronik
                      </p>
                      <p className="mt-2 text-red-700">
                        <b>PASSPHRASE</b> adalah password yang di-set ketika
                        membuat kunci tanda tangan digital Kementrian Agama
                        bersama Badan Siber dan Sandi Nasional (BSSN) Jika kunci
                        salah, maka proses penandatanganan digital akan{' '}
                        <b>GAGAL</b>
                      </p>
                      {tteAction === 'urgent' && (
                        <p className="mt-2 text-red-700">
                          *TTE ini digunakan untuk seluruh sertifikat
                          pengajuanPelatihan termasuk yang tidak lulus
                        </p>
                      )}
                    </div>
                    <button
                      type="button"
                      className="ml-auto -mx-1.5 -my-1.5 bg-yellow-100 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 dark:bg-yellow-200 dark:text-yellow-600 dark:hover:bg-yellow-300"
                      data-dismiss-target="#alert-4"
                      aria-label="Close"
                    >
                      <span className="sr-only">Close</span>
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* Form */}
                  <div>
                    {/* Akun TTE */}
                    <div>
                      <label className="text-sm font-medium text-gray-900">
                        Pilih Akun TTE
                      </label>
                      <div className="mt-3">
                        <Select
                          placeholder="Pilih Akun TTE"
                          options={listAccountTTEOption}
                          isClearable
                          onChange={(selectedOption) =>
                            setAccountTTESelected(selectedOption)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-end -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialog(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => tteSertifikat()}
                  >
                    <If condition={isLoading}>
                      <Then>
                        <ReactLoading
                          type={'bars'}
                          color={'white'}
                          height={15}
                          width={20}
                        />
                      </Then>
                      <Else>Tanda Tangani Sertifikat Secara Digital</Else>
                    </If>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const WrapperMain: React.FC = () => {
  const { getDetailPengajuanPelatihan } =
    useDetailPengajuanPelatihanDataPengajuanPelatihanContext();

  // Detail Konten Pelatihan Context
  const { getModulPelatihan, getPaketSoal, setPengajuanPelatihan } =
    useDetailPengajuanPelatihanKontenPengajuanPelatihanContext();
  const pelatihanId = window.location.pathname.split('/', 6)[5];

  useEffect(() => {
    getDetailPengajuanPelatihan(pelatihanId).then((data) => {
      setPengajuanPelatihan(data);
      getModulPelatihan(data.id);

      getPaketSoal();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const level = GetAuthData()?.level;

  return (
    <SidebarWithHeader>
      <ModalDelete />
      <ModalTolakPengajuan />
      <ModalFormTolakPengajuan />
      <ModalTerimaPengajuan />
      <HeaderBanner />
      {level == 'superadmin' || level == 'admin' ? <ApprovalPelatihan /> : ''}
      <TabsMenu />

      <ModalTTESertifikat />
    </SidebarWithHeader>
  );
};

const DetailDataPengajuanPelatihanManajemenPengajuanPelatihan: React.FC =
  () => {
    return (
      <DetailPengajuanPelatihanController.Provider>
        <DetailPengajuanPelatihanKontenPengajuanPelatihanController.Provider>
          <MasterTTEContext.Provider>
            <ToastContainer
              position="top-center"
              style={{ width: '60%', marginTop: '5%' }}
            />
            <WrapperMain />
          </MasterTTEContext.Provider>
        </DetailPengajuanPelatihanKontenPengajuanPelatihanController.Provider>
      </DetailPengajuanPelatihanController.Provider>
    );
  };

export default DetailDataPengajuanPelatihanManajemenPengajuanPelatihan;
